import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

const UploadButton = forwardRef(({ title = 'Upload', ...props }, ref) => (
  <BaseButton
    ref={ref}
    id='upload-button'
    primary
    icon='upload'
    title={title}
    {...props}
  />
));

export default UploadButton;
